import { createActionGroup, emptyProps, props } from '@ngrx/store'
import { ApplicationError } from '../../../error/model/error'
import { CreditResults, SelectedScenario } from '../../model/credit-results.model'
import { CallTypeSelector } from '../../model/credit-structure.model'

export const CreditResultsActions = createActionGroup({
  source: 'Credit Results',
  events: {
    'Set Selected Scenario': props<{ scenarioId: string; returnPeriod?: string }>(),
    'Set Selected Default Scenario': props<{ scenarioId: string; returnPeriod?: string }>(),
    'Set Call Type': props<{ callType: CallTypeSelector }>(),
    'Set Portfolio Metrics Scenarios': props<{ scenarios: SelectedScenario[] }>(),
    Get: emptyProps(),
    'Get Success': props<{ results: CreditResults }>(),
    'Get Failure': props<{ error: ApplicationError }>(),
    'Get Default': emptyProps(),
    'Get Default Success': props<{ results: CreditResults }>(),
    'Get Default Failure': props<{ error: ApplicationError }>(),
  },
})
